/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_With_DefaultsInputs */

const cs_pipelines_with_defaults = /** @type {(inputs: Pipelines_With_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založit výchozí fáze`)
};

const en_pipelines_with_defaults = /** @type {(inputs: Pipelines_With_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seed default stages`)
};

/**
* | output |
* | --- |
* | "Seed default stages" |
*
* @param {Pipelines_With_DefaultsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_with_defaults = /** @type {((inputs?: Pipelines_With_DefaultsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_With_DefaultsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_with_defaults(inputs)
	return cs_pipelines_with_defaults(inputs)
});